import { getPostHeaders } from "./request";
import { runUnauthorizedHandler } from "./response";

async function deleteRequest(url: string): Promise<void> {
  const requestOptions = {
    method: "DELETE",
    headers: await getPostHeaders()
  };

  const response = await fetch(url, requestOptions);

  if (!response.ok) {
    if (response.status === 401) runUnauthorizedHandler(response);
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}

export default deleteRequest;
